import i18n from 'locales/i18n';
import { SportType } from 'types';

export const SportTranslationsMap: { [key in SportType]: string } = {
  [SportType.laneBased]: i18n.t('sports.sportType.lane'),
  [SportType.courtBased]: i18n.t('sports.sportType.court'),
};
